function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M22 6.28v11.43c0 .18-.09.34-.24.43l-2.89 1.73c-.16.09-.35.09-.51 0l-9.61-5.59a.504.504 0 01-.25-.43v-1.33a.5.5 0 01.76-.43l8.49 5.09c.33.2.76-.04.76-.43V8.42c0-.18-.09-.34-.24-.43l-4.08-2.45a.505.505 0 010-.86l2.57-1.55c.16-.1.36-.1.52 0l4.5 2.7c.13.11.22.28.22.45z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.29 18.43l-4.03 2.42c-.16.1-.36.1-.51 0l-4.5-2.7a.495.495 0 01-.24-.43V6.29c0-.18.09-.34.24-.43l4.5-2.7c.16-.1.36-.1.51 0l9.5 5.7c.15.09.24.25.24.43v4.83a.5.5 0 01-.76.43L7.75 9.46c-.33-.2-.76.04-.76.43v4.83c0 .18.09.34.24.43l4.04 2.43c.34.19.34.65.02.85z"
})));